/**
 * Tiny class to provide a clean interface for keeping track of the playback timestamp
 */
export default class Stopwatch {
  _syncedTimestamp = 0;

  _adjustedStart = null;

  play() {
    if (this.playing) {
      return;
    }
    this._adjustedStart = Date.now() - this._syncedTimestamp * 1000;
  }

  pause() {
    if (!this.playing) {
      return;
    }

    this._syncedTimestamp = this.currentTime;
    this._adjustedStart = null;
  }

  synchronize(timestamp) {
    // Like synchronizing your watch with the atomic clock, but less chernobular
    this._syncedTimestamp = timestamp;
    if (this.playing) {
      this._adjustedStart = Date.now() - this._syncedTimestamp * 1000;
    }
  }

  get playing() {
    return this._adjustedStart !== null;
  }

  get currentTime() {
    if (!this.playing) {
      return this._syncedTimestamp;
    }
    return (Date.now() - this._adjustedStart) / 1000.0;
  }
}
